export default __webpack_public_path__ + "static/media/7t.8a420171.jpg";